import { QUESTION_CREATION_TASK_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { NavigateBackLink, TaskStatusTag } from '@exam-management/components';
import { PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { useQuestionCreationTaskDetails } from '../../providers';
import { MyTaskNavigationTabs } from '../my-task-navigation-tabs';
import { MyTaskPageHeaderAction } from '../my-task-page-header-action';

export default function MyTaskPageHeader() {
  const { task } = useQuestionCreationTaskDetails();

  return (
    <PageHeader
      title={task.name ?? '-'}
      linkAdornment={<NavigateBackLink to='/' replace />}
      endAdornment={
        <>
          <TaskStatusTag
            status={task.status}
            name={task.currentWorkflowStep.name}
            data-testid={QUESTION_CREATION_TASK_DATA_TEST_ID.STATUS_TAG}
          />
          <MyTaskPageHeaderAction />
        </>
      }
      subtitleSection={
        <>
          <Text variant='body2'>Task ID: {task.code}</Text>
          <Text variant='body2'>Last Modified: {formatDateTime(task.updatedAt)}</Text>
        </>
      }
      tabs={<MyTaskNavigationTabs />}
    />
  );
}
